/*
 * pl-foto-cheia — foto do produto em tela cheia (HANDOFF 2c; decisão do Diogo em 25/09/2026).
 *
 * Substitui a lupa de passar o mouse (image-zoom do pacote da agência), que ampliava 2,5x fotos de 1000 px e
 * FECHAVA no clique. Agora, clique numa foto da galeria abre um <dialog> com as fotos da galeria, na mesma ordem:
 * setas, teclas ← → e Esc, deslizar no trackpad (scroll-snap) e o "voltar" do navegador fechando a tela cheia.
 * Um botão no canto da foto faz o mesmo pelo teclado.
 *
 * SÓ NO COMPUTADOR (decisão do Diogo, 25/09): em aparelho de toque (celular, tablet) nada disso liga — a foto já
 * ocupa a largura da tela e o cliente amplia com dois dedos. No iPhone a tela cheia piscava e não abria.
 *
 * As fotos são lidas da galeria NA HORA do clique: o pacote da agência refaz os slides quando o cliente troca de
 * variante (product-images-json), então nada aqui depende de marcação feita pelo Liquid.
 */
(function () {
  'use strict';
  // Só com mouse (hover + ponteiro fino). Navegador sem <dialog> (anterior a 2022) fica com a galeria de sempre.
  var COM_MOUSE = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  if (window.plFotoCheia || typeof HTMLDialogElement === 'undefined' || !COM_MOUSE) return;
  window.plFotoCheia = true;

  var GALERIA = '.main-product__images';
  var SLIDE = '.main-product__image';
  var AREA = '.blaze-track-container';
  var ARRASTE_PX = 8; // mais que isso entre apertar e soltar é arraste do carrossel, não clique
  var LARGURAS = [800, 1200, 1600, 2048]; // a CDN da Shopify nunca devolve maior que o original

  var SVG = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">';
  var ICONE = {
    fechar: SVG + '<path d="M6 6l12 12M18 6L6 18"/></svg>',
    anterior: SVG + '<path d="M15 5l-7 7 7 7"/></svg>',
    proxima: SVG + '<path d="M9 5l7 7-7 7"/></svg>',
    ampliar: SVG + '<path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>'
  };

  var CSS = [
    '.main-product__images .main-product__image{cursor:zoom-in}',
    '.main-product__images .blaze-track-container{position:relative}',
    '.pl-foto-cheia__ampliar{position:absolute;right:10px;bottom:10px;z-index:4;display:flex;align-items:center;',
    'justify-content:center;width:40px;height:40px;padding:0;border:0;border-radius:999px;cursor:pointer;',
    'background:rgba(255,255,255,.92);color:#0d1726;box-shadow:0 2px 8px rgba(13,23,38,.2)}',
    '.pl-foto-cheia__ampliar:hover{background:#fff}',
    '.pl-foto-cheia__ampliar:focus-visible,.pl-foto-cheia button:focus-visible{outline:3px solid #68308d;outline-offset:2px}',
    'dialog.pl-foto-cheia{position:fixed;inset:0;width:100%;height:100%;max-width:none;max-height:none;margin:0;',
    'padding:0;border:0;background:rgba(13,23,38,.96);color:#fff;overflow:hidden}',
    'dialog.pl-foto-cheia::backdrop{background:rgba(13,23,38,.96)}',
    'html:has(dialog.pl-foto-cheia[open]){overflow:hidden}',
    '.pl-foto-cheia__faixa{list-style:none;margin:0;padding:0;display:flex;width:100%;height:100%;overflow-x:auto;',
    'overflow-y:hidden;scroll-snap-type:x mandatory;overscroll-behavior:contain;scrollbar-width:none}',
    '.pl-foto-cheia__faixa::-webkit-scrollbar{display:none}',
    '.pl-foto-cheia__item{flex:0 0 100%;height:100%;box-sizing:border-box;padding:64px 80px 60px;display:flex;',
    'align-items:center;justify-content:center;scroll-snap-align:center;scroll-snap-stop:always}',
    '.pl-foto-cheia__item img{display:block;width:100%;height:100%;object-fit:contain;-webkit-user-drag:none;user-select:none}',
    '.pl-foto-cheia__fechar,.pl-foto-cheia__seta{position:absolute;z-index:1;display:flex;align-items:center;',
    'justify-content:center;width:48px;height:48px;padding:0;border:0;border-radius:999px;cursor:pointer;',
    'background:rgba(255,255,255,.14);color:#fff}',
    '.pl-foto-cheia__fechar:hover,.pl-foto-cheia__seta:hover:not(:disabled){background:rgba(255,255,255,.28)}',
    '.pl-foto-cheia__fechar{top:12px;right:12px}',
    '.pl-foto-cheia__seta{top:50%;transform:translateY(-50%)}',
    '.pl-foto-cheia__seta--anterior{left:16px}.pl-foto-cheia__seta--proxima{right:16px}',
    '.pl-foto-cheia__seta:disabled{opacity:.3;cursor:default}',
    '.pl-foto-cheia [hidden]{display:none!important}',
    '.pl-foto-cheia__contador{position:absolute;left:50%;bottom:16px;transform:translateX(-50%);margin:0;',
    'padding:6px 14px;border-radius:999px;background:rgba(255,255,255,.14);color:#fff;',
    'font:600 14px/1.2 var(--montserrat,system-ui),sans-serif;letter-spacing:.02em}',
    '@media (max-width:767px){.pl-foto-cheia__item{padding:60px 64px 56px}}'
  ].join('');

  var dlg = null, faixa = null, contador = null, anterior = null, proxima = null;
  var total = 0, atual = 0, origem = null, inicio = null, quadro = 0, comHistorico = false;

  function caminho(u) {
    try { return new URL(u, location.href).pathname; } catch (e) { return String(u || ''); }
  }

  function comLargura(u, w) {
    try {
      var x = new URL(u, location.href);
      x.searchParams.set('width', String(w));
      return x.href;
    } catch (e) { return u; }
  }

  function ehFoto(slide) {
    return !!slide && !slide.classList.contains('product-media-item--video') &&
      !slide.querySelector('video, iframe, product-video');
  }

  function imagemDo(slide) {
    return slide.querySelector('img:not(.image-zoom__zoomed)');
  }

  function fotosDa(galeria) {
    var vistas = {}, lista = [];
    var slides = galeria.querySelectorAll(SLIDE);
    for (var n = 0; n < slides.length; n++) {
      if (!ehFoto(slides[n])) continue;
      var img = imagemDo(slides[n]);
      var src = img && (img.currentSrc || img.src);
      if (!src) continue;
      var chave = caminho(src);
      if (vistas[chave]) continue;
      vistas[chave] = true;
      lista.push({ src: src, alt: img.alt || '', chave: chave });
    }
    return lista;
  }

  function montar() {
    dlg = document.createElement('dialog');
    dlg.className = 'pl-foto-cheia';
    dlg.setAttribute('aria-label', 'Fotos do produto em tela cheia');
    dlg.innerHTML =
      '<ul class="pl-foto-cheia__faixa" role="list"></ul>' +
      '<button type="button" class="pl-foto-cheia__fechar" aria-label="Fechar" autofocus>' + ICONE.fechar + '</button>' +
      '<button type="button" class="pl-foto-cheia__seta pl-foto-cheia__seta--anterior" aria-label="Foto anterior">' +
      ICONE.anterior + '</button>' +
      '<button type="button" class="pl-foto-cheia__seta pl-foto-cheia__seta--proxima" aria-label="Próxima foto">' +
      ICONE.proxima + '</button>' +
      '<p class="pl-foto-cheia__contador" aria-live="polite"></p>';
    document.body.appendChild(dlg);

    faixa = dlg.querySelector('.pl-foto-cheia__faixa');
    contador = dlg.querySelector('.pl-foto-cheia__contador');
    anterior = dlg.querySelector('.pl-foto-cheia__seta--anterior');
    proxima = dlg.querySelector('.pl-foto-cheia__seta--proxima');

    dlg.querySelector('.pl-foto-cheia__fechar').addEventListener('click', fechar);
    anterior.addEventListener('click', function () { irPara(atual - 1); });
    proxima.addEventListener('click', function () { irPara(atual + 1); });
    faixa.addEventListener('scroll', function () {
      if (quadro) return;
      quadro = requestAnimationFrame(function () {
        quadro = 0;
        marcar(Math.round(faixa.scrollLeft / Math.max(1, faixa.clientWidth)));
      });
    }, { passive: true });
    // Clique no fundo escuro (fora da foto) fecha, como nas lojas grandes.
    faixa.addEventListener('click', function (e) {
      if (e.target === faixa || e.target.classList.contains('pl-foto-cheia__item')) fechar();
    });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); irPara(atual - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); irPara(atual + 1); }
      // Um script do tema chama preventDefault no Esc e o <dialog> não fecha sozinho (medido 25/09): fecha aqui.
      else if (e.key === 'Escape') { e.preventDefault(); fechar(); }
    });
    dlg.addEventListener('close', function () {
      faixa.innerHTML = ''; // solta as imagens grandes da memória
      if (comHistorico) { comHistorico = false; history.back(); }
      if (origem && document.contains(origem) && typeof origem.focus === 'function') {
        try { origem.focus({ preventScroll: true }); } catch (e) { origem.focus(); }
      }
      origem = null;
    });
    // "Voltar" do celular fecha a tela cheia em vez de sair da página do produto.
    window.addEventListener('popstate', function () {
      if (dlg.open) { comHistorico = false; dlg.close(); }
    });
  }

  function fechar() {
    if (dlg && dlg.open) dlg.close();
  }

  function marcar(i) {
    atual = Math.max(0, Math.min(total - 1, i));
    contador.textContent = (atual + 1) + ' / ' + total;
    contador.hidden = total < 2;
    anterior.hidden = proxima.hidden = total < 2;
    anterior.disabled = atual === 0;
    proxima.disabled = atual === total - 1;
  }

  function irPara(i) {
    if (!total) return;
    i = Math.max(0, Math.min(total - 1, i));
    var suave = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    faixa.scrollTo({ left: i * faixa.clientWidth, behavior: suave ? 'smooth' : 'auto' });
    marcar(i);
  }

  function abrir(fotos, i, alvo) {
    if (!fotos.length) return;
    if (!dlg) montar();
    if (dlg.open) return;
    origem = alvo || null;
    total = fotos.length;
    faixa.innerHTML = '';
    for (var n = 0; n < total; n++) {
      var item = document.createElement('li');
      item.className = 'pl-foto-cheia__item';
      var img = document.createElement('img');
      img.alt = fotos[n].alt;
      img.decoding = 'async';
      img.loading = Math.abs(n - i) <= 1 ? 'eager' : 'lazy';
      img.sizes = '100vw';
      img.srcset = LARGURAS.map(function (w) { return comLargura(fotos[n].src, w) + ' ' + w + 'w'; }).join(', ');
      img.src = comLargura(fotos[n].src, 1200);
      item.appendChild(img);
      faixa.appendChild(item);
    }
    dlg.showModal();
    faixa.scrollLeft = i * faixa.clientWidth; // abre direto na foto clicada, sem animação
    marcar(i);
    try { history.pushState({ plFotoCheia: 1 }, ''); comHistorico = true; } catch (e) { comHistorico = false; }
  }

  function abrirNo(galeria, slide, alvo) {
    var fotos = fotosDa(galeria);
    var img = imagemDo(slide);
    var chave = img ? caminho(img.currentSrc || img.src) : '';
    var i = 0;
    for (var n = 0; n < fotos.length; n++) {
      if (fotos[n].chave === chave) { i = n; break; }
    }
    abrir(fotos, i, alvo);
  }

  function slideVisivel(galeria) {
    var area = galeria.querySelector(AREA);
    if (!area) return null;
    var r = area.getBoundingClientRect();
    var meio = r.left + r.width / 2;
    var slides = galeria.querySelectorAll(SLIDE);
    var melhor = null, distancia = Infinity;
    for (var n = 0; n < slides.length; n++) {
      if (!ehFoto(slides[n])) continue;
      var q = slides[n].getBoundingClientRect();
      var d = Math.abs(q.left + q.width / 2 - meio);
      if (d < distancia) { distancia = d; melhor = slides[n]; }
    }
    return melhor;
  }

  function botaoAmpliar(galeria) {
    var area = galeria.querySelector(AREA);
    if (!area || area.querySelector('.pl-foto-cheia__ampliar')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pl-foto-cheia__ampliar';
    b.setAttribute('aria-label', 'Ver fotos em tela cheia');
    b.innerHTML = ICONE.ampliar;
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      var s = slideVisivel(galeria);
      if (s) abrirNo(galeria, s, b);
    });
    area.appendChild(b);
  }

  document.addEventListener('pointerdown', function (e) {
    var s = e.target.closest && e.target.closest(GALERIA + ' ' + SLIDE);
    inicio = s ? { x: e.clientX, y: e.clientY } : null;
  }, true);

  document.addEventListener('click', function (e) {
    var slide = e.target.closest && e.target.closest(SLIDE);
    var galeria = slide && slide.closest(GALERIA);
    if (!galeria || !ehFoto(slide) || e.target.closest('a[href], button')) return;
    var arrastou = inicio && Math.abs(e.clientX - inicio.x) + Math.abs(e.clientY - inicio.y) > ARRASTE_PX;
    inicio = null;
    if (arrastou) return;
    abrirNo(galeria, slide, slide);
  });

  function iniciar() {
    var galerias = document.querySelectorAll(GALERIA);
    for (var n = 0; n < galerias.length; n++) {
      botaoAmpliar(galerias[n]);
      // O carrossel se refaz ao trocar de variante: recoloca o botão se ele sumir.
      new MutationObserver((function (g) { return function () { botaoAmpliar(g); }; })(galerias[n]))
        .observe(galerias[n], { childList: true, subtree: true });
    }
    if (!document.getElementById('pl-foto-cheia-estilo')) {
      var estilo = document.createElement('style');
      estilo.id = 'pl-foto-cheia-estilo';
      estilo.textContent = CSS;
      document.head.appendChild(estilo);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
